// Turns a vendor's flat colour into the raised-button look by scaling channels, keeping the hue

const scale = (hex, factor) => {
  const h = hex.replace('#', '');
  const full =
    h.length === 3
      ? h
          .split('')
          .map((c) => c + c)
          .join('')
      : h;
  const n = parseInt(full, 16);
  const ch = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) =>
    Math.max(0, Math.min(255, Math.round(c * factor)))
  );
  return '#' + ch.map((c) => c.toString(16).padStart(2, '0')).join('');
};

const rgbOf = (hex) => {
  const h = hex.replace('#', '');
  const full =
    h.length === 3
      ? h
          .split('')
          .map((c) => c + c)
          .join('')
      : h;
  const n = parseInt(full, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(',');
};

// checkColor() returns the literal 'grey' for blocked options; pass it through
// flat so the existing disabled look (grey + opacity 0.25) is unchanged
export const vendorTone = (color) => {
  if (!color || !color.startsWith('#')) {
    return {
      background: color || 'grey',
      boxShadow: 'none',
    };
  }

  // Narrow range on purpose: a bright top stop is the main glare source
  return {
    background: `linear-gradient(160deg, ${scale(color, 1.12)} 0%, ${scale(
      color,
      0.88
    )} 100%)`,
    boxShadow: `0 4px 12px rgba(${rgbOf(
      color
    )},0.2), inset 0 1px 0 rgba(255,255,255,0.14)`,
  };
};

// Shared press feedback; :hover is stripped app-wide by the stylis plugin
export const vendorPressSx = {
  transition: 'transform 80ms ease, box-shadow 80ms ease',
  '&:active': {
    transform: 'translateY(3px)',
    boxShadow:
      '0 2px 6px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.1)',
  },
};

export default vendorTone;
